/**
 * TanStack Query hooks for `postback-domain`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	postbackDomainQueryKeys,
	type CreatePostbackDomainBody,
	type ListPostbackDomainResponse,
	type PostbackDomainRow,
} from "./api";

export function usePostbackDomainList(): UseQueryResult<ListPostbackDomainResponse, Error> {
	return useQuery({
		queryKey: postbackDomainQueryKeys.list(),
		queryFn: list,
	});
}

export function usePostbackDomainCreate(): UseMutationResult<PostbackDomainRow, Error, CreatePostbackDomainBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postbackDomainQueryKeys.all });
		},
	});
}

export function usePostbackDomainDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postbackDomainQueryKeys.all });
		},
	});
}
